<link rel="stylesheet" href="/style/auth.css">
<style>
.container {
  width: 700px;
  min-height: 80vh;
  overflow: auto;
  display: flex;
  align-items: center;
  overflow-x: hidden;
}
.form-container {
  width: 100%;
  height: auto;
  padding: 1rem;
  overflow-x: hidden;
}
</style>
<script>
  import ExtraTVOwnerSignup from '../../tv-pages/auth/ExtraForm.svelte'
  import CreditCardForm from '../shared/forms/CreditCard.svelte'
  export let signupHeader = 'Hello, Friend!'
  export let signupCallToAction = 'Enter your some information and begin your journey with us'
  export let signupUrl = '#'
  export let signupFunc = (email, pass, extraVals={}, creditCardToken=undefined) => {alert(email)}
  let emailVal = null
  let passwordVal = null
  let signupRes = {}
  let businessName = null
  let Extra
  let loading
  let extraValsTvOwner = {}
  let getCardToken
  export let creditCardInfo = false
  export let isTvOwner = false
  async function formSub(e) {
    try {
      e.preventDefault();
      loading = true;
      let creditCardToken
      if (creditCardInfo) {
        creditCardToken = await getCardToken()
      }
      signupFunc(emailVal, passwordVal, businessName, extraValsTvOwner, creditCardToken).then(res => {
        signupRes = res;
        loading = false
      })
    } catch (e) {
      signupRes = e
      loading = false
    }
  }
</script>

<div class="full-screen">
  <div class="container" id="container">
    <div class="form-container">
      <form on:submit={formSub}>
        <h1>Sign Up</h1>
        <!-- <div class="social-container">
          <a href="#" class="social"><i class="fab fa-facebook-f"></i></a>
          <a href="#" class="social"><i class="fab fa-google-plus-g"></i></a>
          <a href="#" class="social"><i class="fab fa-linkedin-in"></i></a>
        </div>
        <span>or use your account</span> -->
        <input type="text" placeholder="Business Name" bind:value={businessName} required />
        <input type="email" placeholder="Email" bind:value={emailVal} required />
        <input type="password" placeholder="Password" bind:value={passwordVal} required />
        {#if creditCardInfo}
          <CreditCardForm bind:getCardToken />
        {/if}
        {#if isTvOwner}
          <ExtraTVOwnerSignup bind:extraVals={extraValsTvOwner}>
          </ExtraTVOwnerSignup>
        {/if}
				{#if signupRes.message}
					<p>
						{signupRes.message}
					</p>
				{/if}
        {#if loading}
          <button class="{loading ? 'loading' : ''}" disabled>Sign Up</button>
        {:else}
          <button>Sign Up</button>
        {/if}
      </form>
    </div>
  </div>
</div>